const triggersForm = {
  bindings: {
    selection: '<',
    fragments: '<',
    triggers: '<',
    onFormSubmit: '&',
    hasEdit: '<',
    isLocked: '<',
  },
  templateUrl:
    '/modules/pis-tool/triggers/triggers-form/triggers-form.html',
  controller: 'TriggersFormController',
};

angular
  .module('pis-tool.module')
  .component('triggersForm', triggersForm);
